import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { FiGithub } from "react-icons/fi";
import { BsInstagram, BsWhatsapp } from "react-icons/bs";

const contactForm = process.env.REACT_APP_CONTACT;

const Contact = () => {
  return (
    <section className="section-padding contact" id="contact">
      <div className="container">
        {/* Section header */}
        <div
          className="text-center section-header"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <span className="sec-label">Get In Touch</span>
          <h2 className="sec-title">Let&rsquo;s Work Together</h2>
          <div className="sec-line" />
        </div>

        <div className="row g-4">
          {/* Form */}
          <div
            className="col-lg-8"
            data-aos="fade-right"
            data-aos-duration="800"
            data-aos-delay="100"
          >
            <div className="contact-form-box">
              <form id="contact-form" method="post" action={contactForm}>
                <div className="message col">
                  <p className="email-loading alert alert-warning">
                    Sending your message…
                  </p>
                  <p className="email-success alert alert-success">
                    Message sent successfully!
                  </p>
                  <p className="email-failed alert alert-danger">
                    Something went wrong. Please try again.
                  </p>
                </div>

                <div className="d-lg-flex gap-3">
                  <div className="w-100">
                    <label htmlFor="contact-name">Your Name</label>
                    <input
                      name="name"
                      id="contact-name"
                      type="text"
                      placeholder="e.g. John Doe"
                      required
                    />
                  </div>
                  <div className="w-100">
                    <label htmlFor="contact-phone">Phone Number</label>
                    <input
                      name="phone"
                      id="contact-phone"
                      type="number"
                      placeholder="e.g. +880 1234 567 890"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="contact-email">Email Address</label>
                  <input
                    name="email"
                    id="contact-email"
                    type="email"
                    placeholder="e.g. hello@example.com"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="contact-subject">Subject</label>
                  <input
                    name="subject"
                    id="contact-subject"
                    type="text"
                    placeholder="What's this about?"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="contact-message">Message</label>
                  <textarea
                    name="message"
                    id="contact-message"
                    placeholder="Tell me about your project or just say hi…"
                    required
                  />
                </div>

                <button type="submit" className="btn-glow">
                  Send Message
                </button>
              </form>
            </div>
          </div>

          {/* Info card */}
          <div
            className="col-lg-4"
            data-aos="fade-left"
            data-aos-duration="800"
            data-aos-delay="200"
          >
            <div className="contact__address">
              <div className="contact__address__image">
                <img src="assets/images/contact1.png" alt="Contact" />
              </div>

              <div className="contact__address__title">
                <h3>Abdul Aziz</h3>
                <p>Frontend Developer</p>
              </div>

              <div className="contact__address__description">
                <p>
                  I&rsquo;m available for freelance work and exciting opportunities.
                  Connect with me — I respond within 24 hours.
                </p>
                <span>
                  Phone:{" "}
                  <a href="tel:+8801887538750">+880 1887 538 750</a>
                </span>
                <span>
                  Email:{" "}
                  <a href="mailto:tamimaziz2007@gmail.com">
                    tamimaziz2007@gmail.com
                  </a>
                </span>
              </div>

              <h4>Find Me On</h4>
              <ul className="social-icon mt-3">
                <li>
                  <a
                    href="https://www.facebook.com/imtamimaziz"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Facebook"
                  >
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/imtamimaziz/"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Instagram"
                  >
                    <BsInstagram />
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/8801887538750"
                    aria-label="WhatsApp"
                  >
                    <BsWhatsapp />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/abdul-aziz-tamim-611b2b306/"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/aziz-tamim"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="GitHub"
                  >
                    <FiGithub />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
